
function load_scrollbar_js(){

	var script = document.createElement('script');
	var script_id = 'mCustomScrollbar';

	if ( document.getElementById( script_id ) ) return;

	script.id = script_id;
	script.src = window.imark.template_dir + '/assets/js/vendor/jquery.' + script_id + '.concat.min.js';

	var style = document.createElement('link');
	style.rel = 'stylesheet';
	style.href = window.imark.template_dir + '/assets/js/vendor/css/jquery.' + script_id + '.css';


	var jquery_script = document.querySelector('script[src*="jquery"]');
	if ( jquery_script ){
		jquery_script.parentNode.insertBefore( script , jquery_script.nextElementSibling )
	}

	document.head.insertBefore( style , document.head.firstElementChild );

}  
 
( function ( $ ) {

	MP.load_article_lightbox = function(){

		const load_article_data = {};

		var btns = document.querySelectorAll( '.box-article-more' );
		
		if ( ! btns.length ) return;

		load_scrollbar_js();

		[].forEach.call( btns, function ( btn ){

			var data = {};

			var text = btn.parentNode.querySelector('.box-article-hiddenText'),
				title = btn.parentNode.querySelector('.box-article-title');

			title && (data.title = title.innerHTML);
			text && (data.content = text.innerHTML);

			btn.addEventListener( 'click' , function(e){

                e.preventDefault();

				lightbox_html( data );

			});

		});

		function lightbox_html(data){

			var holder = document.getElementById( 'post_lb_holder' );

			if ( ! holder ){
				holder = document.createElement('div');
				holder.id = 'post_lb_holder';
				document.body.appendChild( holder );
			}
			holder.innerHTML = 
				'<div class="article-popup l-abs-center l-center" style="display:none">' + 
					'<div class="l-spread article-popup-close"></div>' +
					'<div class="l-layer-up l-column article-popup-body">'+
						'<button class="c-c2 t-line-height btn-close_article_popup article-popup-close">'+
							'<span class="l-center">' +
								'<i class="svgIcon icon-x">' + new SvgIcons().render('x') + '</i>' +
								'<u>' + lib.translation('סגור','close') + '</u>' +
							'</span>' +
						'</button>' +
						'<h3 class="l-clear article-popup-title">' + data.title + '</h3>'+
						'<div class="l-fg1-h0 t-rich_text article-popup-text">' + data.content + '</div>' +
					'</div>'+
				'</div>';

			var $article_popup = $( holder.querySelector('.article-popup') ),
				$article_popup_text = $( holder.querySelector('.article-popup-text'));
			
			$article_popup.fadeIn(300);
			
			! browser.mobile() && $article_popup_text.mCustomScrollbar();

			document.body.classList.add('l-oh', 't-blur');

			$('.article-popup-close').on('click',function(){
				$article_popup.fadeOut(300);
				document.body.classList.remove('l-oh', 't-blur');
			});

		}

		function load_data( id ,callback ){
			
			$.ajax({
				type: "POST",
				dataType: "json",
				url: window.imark.ajaxurl,
				data: 'action=load_post_content&post_id=' + id,
				success: function(data){
					
					load_article_data[id] = data;

					if ( typeof callback === 'function') callback (data);

					clear_spinner();

				},
				error : function (err){
					console.log(err);
					clear_spinner();
				}
			});
		}

		var spinner = document.createElement('div');
		var shadow = document.createElement('div');

		function load_spinner(){

			
			spinner.id = 'article-popup-spinner';
			spinner.className = 'l-spread';
			spinner.innerHTML = '<div class="svgIcon l-abs-center icon-spinner">' +
									new SvgIcons().render('spinner') +
								'</div>';
			document.body.appendChild(spinner);

		}
		function clear_spinner(){
			shadow.appendChild(spinner);
		}

	};

})(window.jQuery);



// WEBPACK FOOTER //
// ./assets/js/m-articles-list.js